<script setup>

import { computed, onMounted, ref, nextTick } from "vue";

const props = defineProps({
  group: {
    type: String,
    default: 'top'
  }
});

const emit = defineEmits(["mounted"]);

const stripsArray = ref(typeof strips !== 'undefined' ? strips.filter(strip => strip.group === props.group) : []);

let currentStripIndex = ref(0);

// If more than one strip, change every 10 seconds
if (stripsArray.value.length) {
  setInterval(() => {
    currentStripIndex.value = (currentStripIndex.value >= stripsArray.value.length - 1) ? 0 : currentStripIndex.value + 1;
  }, Math.random() * (10000 - 4000) + 4000);
}

// Get the current strip
const currentStrip = computed(() => {
  return stripsArray.value.length ? stripsArray.value[currentStripIndex.value] : null;
});

// Get the next strip
const nextStrip = computed(() => {
  const nextIndex = (currentStripIndex.value >= stripsArray.value.length - 1) ? 0 : currentStripIndex.value + 1;
  return stripsArray.value.length ? stripsArray.value[nextIndex] : null;
});

const ready = ref(false);

onMounted(() => {

  ready.value = true;

  // Wait for the next tick to emit the mounted event
  nextTick(() => {
    emit("mounted");
  });

});

const gotoLink = (link) => {
  if (link) {
    window.location.href = link;
  }
};

</script>

<template>
  <div id="stripWrapper" v-if="ready && stripsArray.length" class="strip-container">
    <div v-if="currentStrip" class="strip py-2 px-3" :class="{ 'cursor-pointer link-strip': currentStrip.link }"
      :style="{ 'background-color': currentStrip.background_color, 'color': currentStrip.text_color }"
      @click="gotoLink(currentStrip.link)">
      <div class="text-center" v-html="currentStrip.content"></div>
    </div>
  </div>
</template>

<style scoped>
.strip-container {
  position: relative;
  height: auto;
  overflow: hidden;
}

.strip {
  width: 100%;
  position: relative;
}
</style>